import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { CompanyClient } from 'src/app/trip-calculator/models/companyClients';
import { LogoUploadComponent } from 'src/app/shared/components/logo-upload/logo-upload.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-client-form-dialog',
  standalone: true,
  imports: [
    ButtonModule,
    InputTextModule,
    ReactiveFormsModule,
    DialogModule,
    TranslocoModule,
    LogoUploadComponent,
  ],
  templateUrl: './client-form-dialog.component.html',
})
export class ClientFormDialogComponent implements OnChanges {
  /** Build-time switch, mirrors FEATURE_*_ENABLED on the API. */
  protected readonly features = environment.features;
  @Input() visible = false;
  @Input() mode: 'create' | 'edit' = 'create';
  @Input() client?: CompanyClient;
  @Input() loading = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() save = new EventEmitter<{ name: string; logo?: Blob }>();

  private fb = inject(FormBuilder);
  pendingLogo?: Blob;

  clientForm = this.fb.group({
    name: ['', [Validators.required, Validators.minLength(1)]],
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      this.pendingLogo = undefined;
      if (this.mode === 'edit' && this.client) {
        this.clientForm.patchValue({ name: this.client.name });
      } else {
        this.clientForm.reset();
      }
    }
    if (changes['loading']) {
      const previous = changes['loading'].previousValue;
      const current = changes['loading'].currentValue;
      if (previous === true && current === false) {
        this.closeDialog();
      }
    }
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onLogoCropped(logo: Blob) {
    this.pendingLogo = logo;
  }

  submit() {
    if (this.clientForm.valid) {
      this.save.emit({
        name: this.clientForm.value.name!.trim(),
        logo: this.pendingLogo,
      });
    }
  }
}
